import { useToast } from "@chakra-ui/toast";
import { AlignHorizontalLeftOutlined as AlignHorizontalLeftOutlinedIcon } from "@mui/icons-material";
import { FC, useCallback, useMemo } from "react";

import { DeliverKind } from "~/src/__generated__/schema";
import { IconButton } from "~/src/components/common/IconButton";
import {
  DeliverWeightForm,
  DeliverWeightFormProps,
} from "~/src/components/features/global/DeliverWeightForm";
import { useOpenState } from "~/src/lib/hooks";

import { Chatbot } from "./ChatbotPatternTable";

export type Props = {
  chatbots: Chatbot[];
  deliverKind: DeliverKind;
  onSubmit: (values: DeliverWeightFormProps["initialValues"]) => void;
};

export const ChatbotDeliverWeightButton: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ chatbots, deliverKind, onSubmit }) => {
  const { isOpen, onClose, onOpen } = useOpenState();
  const toast = useToast();

  const initialValues = useMemo<DeliverWeightFormProps["initialValues"]>(() => {
    const deliverWeights = chatbots.map((c) => ({
      id: c.id,
      name: c.name || "",
      weight: c.weight || 1,
    }));
    return { deliverKind, deliverWeights };
  }, [chatbots, deliverKind]);

  const handleSubmit = useCallback<DeliverWeightFormProps["onSubmit"]>(
    (values) => {
      try {
        onSubmit(values);

        onClose();
        toast({
          title: "配信比率の一括更新に成功しました",
          status: "success",
        });
      } catch (err) {
        toast({
          title: "配信比率の一括更新に失敗しました",
          status: "error",
        });
      }
    },
    [onClose, onSubmit, toast]
  );

  return (
    <>
      <IconButton
        size="24px"
        icon={<AlignHorizontalLeftOutlinedIcon />}
        isDisabled={chatbots.length === 0}
        onClick={onOpen}
      />
      <DeliverWeightForm
        isOpen={isOpen}
        initialValues={initialValues}
        onClose={onClose}
        onSubmit={handleSubmit}
      />
    </>
  );
};
